module.exports = __webpack_public_path__ + "static/media/claims_default_label.f4f31b1a.png";